import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {defaultFilter} from "../config";
import {fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import {HttpStatus} from "../../../common/Constants";
import {mapToObjectDDL, removeNullFields} from "../../../common/mapper";

class MasterServiceFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: defaultFilter,
            categoryOptions: [],
            variantOptions: [],
        };
    };

    componentDidMount = async () => {
        this.props.triggerLoading();
        if (this.props.isFilter) {
            await this.setValueFilter();
        }
        await this.fetchDataVariant();
        await this.fetchDataCategory();
        this.props.triggerLoading();
    };

    setValueFilter = () => {
        let {submittedFilterData} = this.props;
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                ...submittedFilterData
            },
        }));
    };

    fetchDataVariant = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
            setError: this.props.setError,
            menuName: "Master Jasa/Job",
            args: null,
        });
        if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
            this.setState((prevValue) => ({
                ...prevValue,
                variantOptions: res.data.data,
            }));
        }
    };

    fetchDataCategory = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
            setError: this.props.setError,
            menuName: "Master Jasa/Job",
            args: {paramFilters: {bizparCategory: "SERVICE_CATEGORY"}},
        });
        if (res.ok && R.equals(res.data.status, HttpStatus.SUCCESS)) {
            this.setState((prevValue) => ({
                ...prevValue,
                categoryOptions: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }));
        }
    };

    handleChangeValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleChangeVariant = (value) => {
        let variant = this.state.variantOptions.find(item => item.kodeVariant === value.value);
        this.handleChangeValue("kodeVarian", mapToObjectDDL(variant.kodeVariant, variant.kodeVariant));
        this.handleChangeValue("namaVarian", mapToObjectDDL(variant.namaVariant, variant.kodeVariant));
    };

    handleClear = () => {
        this.setState((prevValue) => ({...prevValue, filterData: defaultFilter}));
    };

    handleSubmit = () => {
        this.props.onSubmit(removeNullFields(this.state.filterData));
        this.props.onClickClose();
    };

    render() {
        let {filterData, categoryOptions, variantOptions} = this.state;
        return (
            <>
                <SimpleModal
                    title="Filter"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <>
                            <ModalContainer>
                                <SimpleInput
                                    id="input_text_kode_jasa"
                                    name="kodeJasa"
                                    label="Kode Jasa"
                                    value={filterData?.kodeJasa}
                                    onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                />
                                <SimpleInput
                                    id="input_text_nama_jasa"
                                    name="namaJasa"
                                    label="Nama Jasa"
                                    value={filterData?.namaJasa}
                                    onChange={({target}) => this.handleChangeValue(target.name, target.value)}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_service_category"
                                    name="serviceCategory"
                                    label="Category Service"
                                    options={categoryOptions}
                                    value={filterData?.serviceCategory}
                                    onChange={(value, {name}) => this.handleChangeValue(name, value)}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_kode_varian"
                                    name="kodeVarian"
                                    label="Kode Varian"
                                    options={variantOptions.map(item => mapToObjectDDL(item.kodeVariant, item.kodeVariant))}
                                    value={filterData?.kodeVarian}
                                    onChange={(value) => this.handleChangeVariant(value)}
                                />
                                <SimpleDDL
                                    box="search"
                                    id="select_options_nama_varian"
                                    name="namaVarian"
                                    label="Nama Varian"
                                    options={variantOptions.map(item => mapToObjectDDL(item.namaVariant, item.kodeVariant))}
                                    value={filterData?.namaVarian}
                                    onChange={(value) => this.handleChangeVariant(value)}
                                />
                                <FlexView style={{justifyContent: "right"}}>
                                    <SimpleButton onClick={this.handleClear}>Hapus</SimpleButton>
                                    <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                                </FlexView>
                            </ModalContainer>
                        </>
                    }
                />
            </>
        );
    };
}

export default MasterServiceFilter;